/**
 * Spinner — крутящийся индикатор загрузки. Размер задаётся через className (по умолчанию h-4 w-4).
 */
export function Spinner({ className = "h-4 w-4" }: { className?: string }) {
  return <span className={`block animate-spin rounded-full border-2 border-brand border-t-transparent ${className}`} />;
}
